import React from "react";
import { ImageIcon, CheckCircle, XCircle, Heart } from "lucide-react";

interface ModerationStatsProps {
  unmoderatedCount: number;
  approvedCount: number;
  rejectedCount: number;
  totalCount: number;
  onFilterChange: (filter: "unmoderated" | "moderated-ok" | "moderated-ng" | "all") => void;
  onPageReset: () => void;
}

/**
 * 統計情報表示コンポーネント
 * - 未検閲/承認済み/拒否済み/全体の件数表示
 * - クリックでフィルター切り替え
 * - ページリセット機能付き
 */
const ModerationStats: React.FC<ModerationStatsProps> = ({
  unmoderatedCount,
  approvedCount,
  rejectedCount,
  totalCount,
  onFilterChange,
  onPageReset
}) => {
  const handleFilterClick = (filter: "unmoderated" | "moderated-ok" | "moderated-ng" | "all") => {
    onFilterChange(filter);
    onPageReset();
  };

  return (
    <div className="statistics-grid">
      <div 
        className="stat-card pending" 
        onClick={() => handleFilterClick("unmoderated")}
      >
        <div className="stat-icon">
          <ImageIcon size={24} />
        </div>
        <div className="stat-content">
          <div className="stat-number">{unmoderatedCount}</div>
          <div className="stat-label">未検閲</div>
        </div>
      </div>
      
      <div 
        className="stat-card approved" 
        onClick={() => handleFilterClick("moderated-ok")}
      >
        <div className="stat-icon">
          <CheckCircle size={24} />
        </div>
        <div className="stat-content">
          <div className="stat-number">{approvedCount}</div>
          <div className="stat-label">承認済み</div>
        </div>
      </div>
      
      <div 
        className="stat-card rejected" 
        onClick={() => handleFilterClick("moderated-ng")}
      >
        <div className="stat-icon">
          <XCircle size={24} />
        </div>
        <div className="stat-content">
          <div className="stat-number">{rejectedCount}</div>
          <div className="stat-label">拒否済み</div>
        </div>
      </div>
      
      <div 
        className="stat-card selected" 
        onClick={() => handleFilterClick("all")}
      >
        <div className="stat-icon">
          <Heart size={24} />
        </div>
        <div className="stat-content">
          <div className="stat-number">{totalCount}</div>
          <div className="stat-label">すべて</div>
        </div>
      </div>
    </div>
  );
};

export default ModerationStats;